import api from "./api";

// 查询内容列表
export const fetchMarketContentList = params => {
  return api("post", `/v1/management/marketContent/list`, params);
};

// 查询内容分类
export const fetchTypeList = params => {
  return api("get", `/v1/management/marketContent/marketType`, params);
};

// 获取市场内容详情
export const fetchMarketContent = params => {
  return api("get", `/v1/management/marketContent/info/${params}`);
};

// 新增市场内容
export const addMarketContent = params => {
  return api("post", `/v1/management/marketContent/add`, params);
};

// 保存预览并生成二维码
export const previewAdd = params => {
  return api("post", `v1/management/marketContent/preview-add`, params);
};

// 修改市场内容
export const updateMarketContent = params => {
  return api("post", `/v1/management/marketContent/update`, params);
};

// 删除市场内容
export const deleteMarketContent = params => {
  return api("post", `/v1/management/marketContent/delete/${params}`);
};

// 置顶内容
export const postStickyContent = params => {
  return api("post", `/v1/management/marketContent/sticky/${params}`);
};

// 取消置顶内容
export const postUnStickyContent = params => {
  return api("post", `/v1/management/marketContent/cancel-sticky/${params}`);
};

// 上架内容
export const postOnlineContent = params => {
  return api("post", `/v1/management/marketContent/publish`, params);
};

// 下架内容
export const postOfflineContent = params => {
  return api("post", `/v1/management/marketContent/offline`, params);
};
